import { AnaColumn } from "../forms-template.service";

export const comuni: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", colSpan: "2", data: [
        {
          type: 'campo', disableOnUpdate: true, editorType:'dxTextBox',   dataField: "id", minLength: "6", maxLength: "6", dataType: "string", caption: "ISTAT",
        
          validation: [
            { type: "stringLength", min: "6", max: "6", message: "Campo Obbligatorio" },
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campo', dataField: "descrizione", dataType: "", caption: "DENOMINAZIONE",
          sortOrder:'asc',
          validation: [{ type: "required", message: "Campo Obbligatorio" }]
        },
        {
          type: 'campo', dataField: "cap", minLength: "5", maxLength: "5", dataType: "", caption: "CAP",
          validation: [
            { type: "pattern", pattern: "^[0-9]+$", min: "5", message: "Solo Valori Numerici" },
            { type: "stringLength", max: "5", min: "5", message: "Il valore deve avere una lunghezza minima di 5 caratteri" },
            { type: "required", message: "Campo Obbligatorio" }
          ]
        },
        { type: 'campo', dataField: "catasto", dataType: "", maxLength: "4", caption: "CATASTO",
        
       },
       
        {
          type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PROVINCIA",
          
          validation: [{ type: "required", message: "Campo Obbligatorio" }],
          lista: {
            dataSource: 'provincia',
            displayExpr: 'siglaProvincia',
            valueExpr: 'siglaProvincia',
            static: false
          }
        },
        
      ]
    },
  ]